import { FC } from "react";
import HeadSection from "../../components/HeadSection";
import i18n from "../../i18n";
import { calendarTranslations } from "./calendar_translation";
import { useTranslation } from "react-i18next";
import { title } from "process";
import { iconButtonClasses } from "@mui/material";
import Filter from "../../components/Filter";

i18n.addResourceBundle('en', 'calendar', calendarTranslations.en);
i18n.addResourceBundle('fr', 'calendar', calendarTranslations.fr);

interface CalendarProps  {
    nom:String,
};

const Calendar: FC<any> =() => {
    const { t } = useTranslation('calendar');
    return ( <>
    <div className="flex min-h-[200px] flex-col px-[3%] text-xl lg:px-[15%]">
        <HeadSection title={t('titles.head1')} trailling={<Filter/>} style={""}></HeadSection>
        <section className="flex min-h-[200px] w-full items-center justify-center"> section all event 1 </section>
        <HeadSection title={t('titles.head2')} trailling={null} style={""}></HeadSection>
        <section className="flex h-96 w-full items-center justify-center"> section all event 2 </section>
        <HeadSection title={t('titles.head3')} trailling={null} style={""}></HeadSection>
        <section className="flex h-96 w-full items-center justify-center"> section all event 3</section>
      </div></>);
}
export default Calendar;